import { classNames } from '@oracle/oraclejet-preact/utils/classNames';
import { expect } from 'chai';

describe('Utilities', () => {
  it('joins values into a string', () => {
    expect(classNames(['A', 'B', false, 'D'])).equals('A B D');
    expect(classNames(['A'])).equals('A');
    expect(classNames([false])).equals('');
  });
});
